/**
 * Why the practice decided not to charge a pending `CancellationFee`
 * (TM-9064 Erlassen). Enum from day one so the reason is reportable —
 * the free-text field is supplementary, not a substitute.
 */
export var CancellationFeeWaiverReason;
(function (CancellationFeeWaiverReason) {
    /** The wasted slot was re-filled — no actual revenue loss. */
    CancellationFeeWaiverReason["SLOT_REFILLED"] = "slot_refilled";
    /** Goodwill / patient-relationship decision. */
    CancellationFeeWaiverReason["GOODWILL"] = "goodwill";
    /** Hardship / patient unable to pay. */
    CancellationFeeWaiverReason["HARDSHIP"] = "hardship";
    /** First-time occurrence, practice chooses leniency. */
    CancellationFeeWaiverReason["FIRST_TIME"] = "first_time";
    /** Falls outside the catch-all categories above; free-text required. */
    CancellationFeeWaiverReason["OTHER"] = "other";
})(CancellationFeeWaiverReason || (CancellationFeeWaiverReason = {}));
//# sourceMappingURL=cancellation-fee-waiver-reason.enum.js.map